import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Play, Headset, CreditCard, Calculator, Wrench, Truck, Package, MapPin, Plus, Lock, X, ChevronLeft, ChevronRight, Image as ImageIcon, Images, List as ListIcon } from 'lucide-react';
type VideoSlot = {
  title: string;
  description?: string;
  duration?: string;
  videoUrl?: string;
  youtubeId?: string;
  imageUrl?: string;
  imageUrls?: string[];
  listItems?: {
    label: string;
    value: string;
    url?: string;
    imageUrl?: string;
  }[];
  comingSoon?: boolean;
};
type VideoCategory = {
  id: string;
  title: string;
  description: string;
  icon: any;
  accent: string;
  videos: VideoSlot[];
};
const videoLibrary: VideoCategory[] = [{
  id: 'dispatch',
  title: 'Dispatch & Operations',
  description: 'How the dispatch desk runs day & night.',
  icon: Headset,
  accent: 'text-blue-600 dark:text-blue-400 bg-blue-500/10',
  videos: [{
    title: 'How Dispatch Works',
    imageUrl: 'https://cdn.magicpatterns.com/uploads/qq2cDtZ8GGE5JtbhLeFuB8/image3_(1).jpg'
  }, {
    title: 'Incoming Call Process',
    imageUrls: ['https://cdn.magicpatterns.com/uploads/vuYaBNg8AXSVpomoMPKzid/ChatGPT_Image_May_16,_2026,_01_16_25_PM.png', 'https://cdn.magicpatterns.com/uploads/aixzQ6AuKe9BQurxMGNX5K/ChatGPT_Image_May_16,_2026,_01_16_29_PM.png', 'https://cdn.magicpatterns.com/uploads/2mBWXWwo1ZctAtxVqU9KGj/ChatGPT_Image_May_16,_2026,_01_17_22_PM.png', 'https://cdn.magicpatterns.com/uploads/2JLn9AQqQSJQJ6kZ17v4eF/ChatGPT_Image_May_16,_2026,_01_18_13_PM.png', 'https://cdn.magicpatterns.com/uploads/h9yeXKYFtwXCtyQ4orxsCu/ChatGPT_Image_May_16,_2026,_01_20_05_PM.png', 'https://cdn.magicpatterns.com/uploads/96hk3H5JXCiaqtf6D25isq/ChatGPT_Image_May_16,_2026,_01_23_40_PM.png']
  }, {
    title: 'How to Assign a Mechanic',
    imageUrls: ['https://cdn.magicpatterns.com/uploads/3jTs3VNVCUkQUF8VigCjn3/image0_(2).jpg', 'https://cdn.magicpatterns.com/uploads/4tBysZo1JcHtWS9UBm8XYr/image1_(2).jpg', 'https://cdn.magicpatterns.com/uploads/qe4541jSD5o1DRMtYrR4by/image2_(1).jpg']
  }, {
    title: 'Parts Coordination',
    description: 'Mechanic dispatched to multiple suppliers for parts pickup prior to arriving on-site for service completion.',
    imageUrls: ['https://cdn.magicpatterns.com/uploads/rRyMtQYCDKKH55cKkf8erY/WhatsApp_Image_2026-05-16_at_12.52.25_PM.jpg', 'https://cdn.magicpatterns.com/uploads/vPJhbnPcKzb4PyEqNM4ka6/WhatsApp_Image_2026-05-16_at_12.52.26_PM.jpg', 'https://cdn.magicpatterns.com/uploads/6BBsAqBzVbVXhHWUjQEmFD/WhatsApp_Image_2026-05-16_at_12.52.26_PM_(1).jpg', 'https://cdn.magicpatterns.com/uploads/7en6HKrFKWN6XaBn2DRtcC/WhatsApp_Image_2026-05-16_at_12.52.26_PM_(2).jpg']
  }]
}, {
  id: 'payments',
  title: 'Payment Processing',
  description: 'Step-by-step payment collection workflows.',
  icon: CreditCard,
  accent: 'text-emerald-600 dark:text-emerald-400 bg-emerald-500/10',
  videos: [{
    title: 'How to Process a Comcheck',
    imageUrl: 'https://cdn.magicpatterns.com/uploads/voc2QtdS9WiWJ1hDFUxpmP/image0_(2).png'
  }, {
    title: 'How to Process EFS Payments',
    imageUrl: 'https://cdn.magicpatterns.com/uploads/5FnKihjrRVmSEUxjMBhiXh/image0_(3).png'
  }, {
    title: 'How to Process T-Check',
    imageUrl: 'https://cdn.magicpatterns.com/uploads/gnAJr9jNa1FH7757f6fmj5/image1_(1).png'
  }, {
    title: 'Check Reports',
    imageUrl: 'https://cdn.magicpatterns.com/uploads/9eMWGVSc4iGBDoKz1hpwKB/WhatsApp_Image_2026-05-16_at_12.56.41_PM.jpg'
  }]
}, {
  id: 'quickbooks',
  title: 'QuickBooks & Accounting',
  description: 'Invoicing, payment links, and reporting.',
  icon: Calculator,
  accent: 'text-purple-600 dark:text-purple-400 bg-purple-500/10',
  videos: [{
    title: 'How to Use QuickBooks',
    youtubeId: 'w3agU6-zc_M'
  }, {
    title: 'How to Generate an Invoice',
    videoUrl: 'https://cdn.magicpatterns.com/uploads/9L7GmkyVeHdw9jUaP8NbCi/WhatsApp%20Video%202026-05-16%20at%201.34.19%20PM.mp4'
  }, {
    title: 'How to Send a Square Payment Link',
    videoUrl: 'https://cdn.magicpatterns.com/uploads/dtyZo49dm5GRfN4i8xVKae/WhatsApp%20Video%202026-05-15%20at%2010.51.43%20PM.mp4'
  }, {
    title: 'Track Customer Payment',
    imageUrl: 'https://cdn.magicpatterns.com/uploads/pGfM3KFXU1bKhkhba2ixMC/WhatsApp_Image_2026-05-16_at_1.06.00_PM.jpg'
  }]
}, {
  id: 'field',
  title: 'Field Operations',
  description: 'How mechanics work on the road.',
  icon: Wrench,
  accent: 'text-amber-600 dark:text-amber-400 bg-amber-500/10',
  videos: [{
    title: 'Mechanic Arrival Procedure',
    imageUrls: ['https://cdn.magicpatterns.com/uploads/5JMR4gmwNBLvd8ZH4awxqS/image0_(1).jpg', 'https://cdn.magicpatterns.com/uploads/ercQ1LX82Gaa7MKYZcYKou/image1_(2).jpg']
  }, {
    title: 'On-Site Diagnostics Walkthrough',
    imageUrls: ['https://cdn.magicpatterns.com/uploads/j7dpcdAZDz28jAFMNHBtJS/image1_(1).jpg', 'https://cdn.magicpatterns.com/uploads/q64kD2pPHUH6UoDvsfiq4k/image2_(1).jpg', 'https://cdn.magicpatterns.com/uploads/cXVEojzkKMyHmpczUsGNmp/image3_(1).jpg']
  }, {
    title: 'Customer Review',
    videoUrl: 'https://cdn.magicpatterns.com/uploads/27VFNw1XHcY6AU6wz4cyRA/WhatsApp%20Video%202026-05-16%20at%2012.44.59%20PM.mp4'
  }]
}, {
  id: 'fleet',
  title: 'Fleet & Vehicles',
  description: 'Service truck setup and maintenance.',
  icon: Truck,
  accent: 'text-rose-600 dark:text-rose-400 bg-rose-500/10',
  videos: [{
    title: 'Service Truck Walkaround',
    imageUrls: ['https://cdn.magicpatterns.com/uploads/vd2B7giWyFtuLBeTvnKDFB/WhatsApp_Image_2026-05-16_at_1.53.49_PM.jpg', 'https://cdn.magicpatterns.com/uploads/o1jJX4uLka6hFRDreQ7GPC/WhatsApp_Image_2026-05-16_at_1.53.49_PM_(1).jpg', 'https://cdn.magicpatterns.com/uploads/mZZXVNGDwJmfnHvxgnCnoW/WhatsApp_Image_2026-05-16_at_1.53.49_PM_(2).jpg']
  }, {
    title: 'Service Truck Tools',
    comingSoon: true
  }, {
    title: 'GPS Tracking Overview',
    imageUrl: 'https://cdn.magicpatterns.com/uploads/aFAUxwQoaseqhychbds5ta/image.png'
  }]
}, {
  id: 'inventory',
  title: 'Inventory & Parts',
  description: 'Stocking, tracking, and supplier relationships.',
  icon: Package,
  accent: 'text-cyan-600 dark:text-cyan-400 bg-cyan-500/10',
  videos: [{
    title: 'Stock - Google Sheets',
    comingSoon: true
  }, {
    title: 'Where To Buy ?',
    listItems: [{
      label: 'Tires',
      value: 'ATD and MPF Truck Solutions'
    }, {
      label: 'Batteries',
      value: 'Nextran or Freightliner'
    }, {
      label: 'Trailer Parts',
      value: 'FleetPride, Davids Trailer, Utility Trailer'
    }]
  }, {
    title: 'Parts Purchased in Amazon',
    listItems: [{
      label: 'Air Line Hose with Glad Hands',
      value: 'View on Amazon',
      url: 'https://www.amazon.com/dp/B09QG6C4MZ?ref_=cm_sw_r_cp_ud_dp_81J8KX6PS4Y0R5EP3ARG',
      imageUrl: 'https://cdn.magicpatterns.com/uploads/sh4nLKpSnG72PFscBsACsQ/image.png'
    }, {
      label: 'Push-to-Connect Air Manifold Block',
      value: 'View on Amazon',
      url: 'https://www.amazon.com/dp/B0CCQBHNCS?ref_=cm_sw_r_cp_ud_dp_X3GJKM0GWEZNE37E60Z3',
      imageUrl: 'https://cdn.magicpatterns.com/uploads/qKmXy816qREPGV12ZThQZk/image.png'
    }, {
      label: 'Trailer Brake Drum Kit with Bearings',
      value: 'View on Amazon',
      url: 'https://a.co/d/0j6CeJNt',
      imageUrl: 'https://cdn.magicpatterns.com/uploads/ccAVYGcfkWVChthrq2kwKt/image.png'
    }, {
      label: '3/8" Hose End Repair Kit (Quick Fix)',
      value: 'View on Amazon',
      url: 'https://a.co/d/0cEl4YDr',
      imageUrl: 'https://cdn.magicpatterns.com/uploads/oi88bedR5J8EQGaxNkYCrM/image.png'
    }, {
      label: 'Pair of Silver Trailer Wheels / Rims',
      value: 'View on Amazon',
      url: 'https://a.co/d/08PUvde6',
      imageUrl: 'https://cdn.magicpatterns.com/uploads/kwd4aW6PTZKX3QGRpXVSFG/image.png'
    }, {
      label: 'Trailer Brake Drum Kit (Alternative)',
      value: 'View on Amazon',
      url: 'https://www.amazon.com/dp/B0DLWJVG81?ref_=cm_sw_r_cp_ud_dp_DSYS2RWCDVY3C3TY4FT8',
      imageUrl: 'https://cdn.magicpatterns.com/uploads/xkdAnzCAgbMTceztnii8Gi/image.png'
    }, {
      label: 'Air Brake Relay Valve',
      value: 'View on Amazon',
      url: 'https://a.co/d/0h8uMka6',
      imageUrl: 'https://cdn.magicpatterns.com/uploads/eZX9DVNz6CfDfkhUVDBaoQ/image.png'
    }, {
      label: 'Air Brake Control Valve',
      value: 'View on Amazon',
      url: 'https://www.amazon.com/dp/B00IVQR2U6?ref_=cm_sw_r_cp_ud_dp_57ZYX0DA9VTZKV1GWX1K',
      imageUrl: 'https://cdn.magicpatterns.com/uploads/tt3XsVv4q6UqdJqaiedZRv/image.png'
    }, {
      label: 'Complete Trailer Brake Assembly Kit',
      value: 'View on Amazon',
      url: 'https://www.amazon.com/dp/B0BVBJJ4BJ?ref_=cm_sw_r_cp_ud_dp_T47PW16Z05PV3CKTCF9Q',
      imageUrl: 'https://cdn.magicpatterns.com/uploads/dbiCGEe6f2WcuNFJvChXtG/image.png'
    }, {
      label: 'Trailer Idler Hub Kit with Bearings',
      value: 'View on Amazon',
      url: 'https://www.amazon.com/dp/B0BJ8V8KKC?ref_=cm_sw_r_cp_ud_dp_GSTD4M8S51FQB3HHAK6Q',
      imageUrl: 'https://cdn.magicpatterns.com/uploads/7sjx1n6DJ6H5RxLnZRrj4Z/image.png'
    }, {
      label: 'Air Dryer Assembly (R950011)',
      value: 'View on Amazon',
      url: 'https://www.amazon.com/dp/B0CTS949XS?ref_=cm_sw_r_cp_ud_dp_7H73D58DB90ESXJ0RWPR',
      imageUrl: 'https://cdn.magicpatterns.com/uploads/tAcPPd36gYAthbKx9T8YDs/image.png'
    }]
  }]
}];
type ActiveMedia = {
  kind: 'video';
  url: string;
  title: string;
  description?: string;
} | {
  kind: 'youtube';
  youtubeId: string;
  title: string;
  description?: string;
} | {
  kind: 'image';
  url: string;
  title: string;
  description?: string;
} | {
  kind: 'gallery';
  urls: string[];
  title: string;
  description?: string;
} | {
  kind: 'list';
  items: {
    label: string;
    value: string;
    url?: string;
    imageUrl?: string;
  }[];
  title: string;
  description?: string;
};
function MediaModal({
  media,
  onClose
}: {
  media: ActiveMedia;
  onClose: () => void;
}) {
  const [index, setIndex] = useState(0);
  useEffect(() => {
    setIndex(0);
  }, [media]);
  useEffect(() => {
    function onKey(e: KeyboardEvent) {
      if (e.key === 'Escape') onClose();
      if (media.kind === 'gallery') {
        if (e.key === 'ArrowRight') {
          setIndex(i => (i + 1) % media.urls.length);
        } else if (e.key === 'ArrowLeft') {
          setIndex(i => (i - 1 + media.urls.length) % media.urls.length);
        }
      }
    }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [media, onClose]);
  const mediaSizing = 'block max-h-[78vh] sm:max-h-[80vh] max-w-[92vw] w-auto h-auto object-contain rounded-md';
  return <div className="fixed inset-0 z-50 flex items-center justify-center bg-background/80 backdrop-blur-sm p-3 sm:p-6 animate-in fade-in duration-200" onClick={onClose} data-id="element-10">
      <div className="relative flex flex-col max-w-[95vw] max-h-[92vh] rounded-xl border bg-card shadow-2xl overflow-hidden animate-in zoom-in-95 duration-200" onClick={e => e.stopPropagation()} data-id="element-11">
        {/* Header */}
        <div className="flex flex-col border-b px-4 py-3 shrink-0 min-w-[280px]" data-id="element-12">
          <div className="flex items-center justify-between gap-3" data-id="element-13">
            <h3 className="font-semibold text-foreground truncate min-w-0 flex-1" data-id="element-14">
              {media.title}
              {media.kind === 'gallery' && <span className="ml-2 text-xs font-medium text-muted-foreground" data-id="element-15">
                  ({index + 1} / {media.urls.length})
                </span>}
            </h3>
            <button onClick={onClose} className="shrink-0 rounded-md p-1 text-muted-foreground hover:bg-muted hover:text-foreground transition-colors" aria-label="Close" data-id="element-16">
              <X className="h-5 w-5" data-id="element-17" />
            </button>
          </div>
          {media.description && <p className="mt-1.5 text-sm text-muted-foreground leading-snug max-w-3xl" data-id="element-18">
              {media.description}
            </p>}
        </div>

        {/* Body */}
        {media.kind === 'video' ? <div className="bg-black flex items-center justify-center" data-id="element-19">
            <video src={media.url} controls autoPlay className={mediaSizing} data-id="element-20" />
          </div> : media.kind === 'youtube' ? <div className="bg-black flex items-center justify-center" data-id="element-21">
            <div className="aspect-video bg-black" style={{
          width: 'min(90vw, calc((78vh - 0px) * 16 / 9))'
        }} data-id="element-22">
              <iframe src={`https://www.youtube.com/embed/${media.youtubeId}?autoplay=1&rel=0&modestbranding=1`} title={media.title} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen className="w-full h-full" data-id="element-23" />
            </div>
          </div> : media.kind === 'image' ? <div className="bg-muted/30 p-2 sm:p-3 flex items-center justify-center" data-id="element-24">
            <img src={media.url} alt={media.title} className={mediaSizing} data-id="element-25" />
          </div> : media.kind === 'list' ? <div className="bg-muted/10 p-6 flex-1 overflow-y-auto" data-id="element-26">
            <div className="max-w-2xl mx-auto space-y-4" data-id="element-27">
              {media.items.map((item, i) => <div key={i} className="flex flex-col sm:flex-row sm:items-center justify-between p-4 rounded-lg border bg-card shadow-sm gap-4" data-id="element-28">
                  <div className="flex items-center gap-4" data-id="element-29">
                    {item.imageUrl && <div className="h-12 w-12 shrink-0 rounded-md border bg-muted overflow-hidden flex items-center justify-center" data-id="element-30">
                        <img src={item.imageUrl} alt={item.label} className="object-cover w-full h-full" data-id="element-31" />
                      </div>}
                    <span className="font-medium text-foreground mb-1 sm:mb-0" data-id="element-32">
                      {item.label}
                    </span>
                  </div>
                  {item.url ? <a href={item.url} target="_blank" rel="noopener noreferrer" className="text-primary hover:underline text-sm font-medium shrink-0" data-id="element-33">
                      {item.value}
                    </a> : <span className="text-muted-foreground text-sm shrink-0" data-id="element-34">
                      {item.value}
                    </span>}
                </div>)}
            </div>
          </div> :
      // Gallery / carousel
      <div className="relative bg-muted/30 p-2 sm:p-3 flex items-center justify-center" data-id="element-35">
            <img src={media.urls[index]} alt={`${media.title} – step ${index + 1}`} className={mediaSizing} data-id="element-36" />

            <button type="button" onClick={() => setIndex(i => (i - 1 + media.urls.length) % media.urls.length)} aria-label="Previous image" className="absolute left-2 sm:left-3 top-1/2 -translate-y-1/2 flex h-10 w-10 items-center justify-center rounded-full bg-background/90 border shadow-md text-foreground hover:bg-background transition-colors" data-id="element-37">
              <ChevronLeft className="h-5 w-5" data-id="element-38" />
            </button>

            <button type="button" onClick={() => setIndex(i => (i + 1) % media.urls.length)} aria-label="Next image" className="absolute right-2 sm:right-3 top-1/2 -translate-y-1/2 flex h-10 w-10 items-center justify-center rounded-full bg-background/90 border shadow-md text-foreground hover:bg-background transition-colors" data-id="element-39">
              <ChevronRight className="h-5 w-5" data-id="element-40" />
            </button>

            <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex items-center gap-1.5 rounded-full bg-background/85 backdrop-blur border px-2.5 py-1.5 shadow-sm" data-id="element-41">
              {media.urls.map((_, i) => <button key={i} type="button" onClick={() => setIndex(i)} aria-label={`Go to image ${i + 1}`} className={`h-1.5 rounded-full transition-all ${i === index ? 'w-5 bg-primary' : 'w-1.5 bg-muted-foreground/40 hover:bg-muted-foreground/70'}`} data-id="element-42" />)}
            </div>
          </div>}
      </div>
    </div>;
}
function VideoCard({
  title,
  description,
  accentBg,
  videoUrl,
  youtubeId,
  imageUrl,
  imageUrls,
  listItems,
  comingSoon,
  onOpen
}: {
  title: string;
  description?: string;
  accentBg: string;
  videoUrl?: string;
  youtubeId?: string;
  imageUrl?: string;
  imageUrls?: string[];
  listItems?: {
    label: string;
    value: string;
    url?: string;
    imageUrl?: string;
  }[];
  comingSoon?: boolean;
  onOpen: (media: ActiveMedia) => void;
}) {
  const hasVideo = !!videoUrl;
  const hasYoutube = !!youtubeId;
  const hasGallery = !!imageUrls && imageUrls.length > 0;
  const hasImage = !!imageUrl;
  const hasList = !!listItems && listItems.length > 0;
  const Icon = hasList ? ListIcon : hasGallery ? Images : ImageIcon;
  return <button type="button" onClick={() => {
    if (hasVideo) onOpen({
      kind: 'video',
      url: videoUrl!,
      title,
      description
    });else if (hasYoutube) onOpen({
      kind: 'youtube',
      youtubeId: youtubeId!,
      title,
      description
    });else if (hasGallery) onOpen({
      kind: 'gallery',
      urls: imageUrls!,
      title,
      description
    });else if (hasImage) onOpen({
      kind: 'image',
      url: imageUrl!,
      title,
      description
    });else if (hasList) onOpen({
      kind: 'list',
      items: listItems!,
      title,
      description
    });
  }} className="group relative flex w-full items-center gap-3 rounded-lg border bg-card p-3 text-left shadow-sm transition-all hover:border-primary/40 hover:shadow-md" data-id="element-43">
      <div className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-md ${accentBg} transition-transform group-hover:scale-105`} data-id="element-44">
        {hasVideo || hasYoutube ? <Play className="h-4 w-4 fill-current" data-id="element-45" /> : <Icon className="h-4 w-4" data-id="element-46" />}
      </div>
      <div className="flex-1 min-w-0" data-id="element-47">
        <div className="text-sm font-medium text-foreground leading-tight" data-id="element-48">
          {title}
        </div>
        <div className="text-[11px] text-muted-foreground mt-1 flex items-center gap-1" data-id="element-49">
          {hasVideo ? <span className="text-primary font-medium" data-id="element-50">Watch video</span> : hasYoutube ? <span className="text-primary font-medium" data-id="element-51">Watch on YouTube</span> : hasGallery ? <span className="text-primary font-medium" data-id="element-52">
              View guide · {imageUrls!.length} photos
            </span> : hasImage ? <span className="text-primary font-medium" data-id="element-53">View guide</span> : hasList ? <span className="text-primary font-medium" data-id="element-54">View list</span> : comingSoon ? <span className="text-muted-foreground font-medium" data-id="element-55">
              Coming soon
            </span> : <>
              <Plus className="h-3 w-3" data-id="element-56" />
              Upload video
            </>}
        </div>
      </div>
    </button>;
}
export function Footer() {
  const [activeMedia, setActiveMedia] = useState<ActiveMedia | null>(null);
  return <footer id="training-library" className="mt-16 border-t bg-muted/30" data-id="element-57">
      {activeMedia && <MediaModal media={activeMedia} onClose={() => setActiveMedia(null)} data-id="element-58" />}

      {/* Quick Access Dashboard / Video Library */}
      <div className="px-4 sm:px-6 lg:px-8 py-12 max-w-6xl mx-auto" data-id="element-59">
        <div className="mb-8 flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3" data-id="element-60">
          <div data-id="element-61">
            <div className="inline-flex items-center gap-2 rounded-full bg-primary/10 px-3 py-1 text-xs font-medium uppercase tracking-wider text-primary mb-3" data-id="element-62">
              <Play className="h-3 w-3 fill-current" data-id="element-63" />
              Training Library
            </div>
            <h2 className="text-2xl font-bold tracking-tight text-foreground" data-id="element-64">
              Quick Access Dashboard
            </h2>
            <p className="mt-2 text-sm text-muted-foreground max-w-2xl" data-id="element-65">
              A growing library of training videos and walkthroughs covering
              every operational workflow. Designed so the new owner can hand
              this same library to dispatchers, mechanics, and future hires.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-66">
          {videoLibrary.map(cat => {
          const Icon = cat.icon;
          return <div key={cat.id} className="rounded-xl border bg-card p-5 shadow-sm" data-id="element-67">
                <div className="flex items-start gap-3 mb-4 pb-4 border-b" data-id="element-68">
                  <div className={`flex h-9 w-9 items-center justify-center rounded-md ${cat.accent}`} data-id="element-69">
                    <Icon className="h-4 w-4" data-id="element-70" />
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-71">
                    <div className="text-sm font-semibold text-foreground" data-id="element-72">
                      {cat.title}
                    </div>
                    <div className="text-xs text-muted-foreground mt-0.5" data-id="element-73">
                      {cat.description}
                    </div>
                  </div>
                  <span className="text-[11px] font-medium text-muted-foreground bg-muted px-2 py-0.5 rounded-full" data-id="element-74">
                    {cat.videos.length}
                  </span>
                </div>

                <div className="space-y-2" data-id="element-75">
                  {cat.videos.map(v => <VideoCard key={v.title} title={v.title} description={v.description} accentBg={cat.accent} videoUrl={v.videoUrl} youtubeId={v.youtubeId} imageUrl={v.imageUrl} imageUrls={v.imageUrls} listItems={v.listItems} comingSoon={v.comingSoon} onOpen={m => setActiveMedia(m)} data-id="element-76" />)}
                </div>
              </div>;
        })}
        </div>
      </div>

      {/* Bottom strip */}
      <div className="border-t bg-background" data-id="element-77">
        <div className="px-4 sm:px-6 lg:px-8 py-6 max-w-6xl mx-auto flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4" data-id="element-78">
          <div className="flex items-center gap-3" data-id="element-79">
            <img src="https://cdn.magicpatterns.com/uploads/avqgHrdxVGXkmw7ePFFRH3/ChatGPT_Image_May_15,_2026,_10_04_03_PM.png" alt="CES Mobile Truck Repair" className="h-8 w-8 object-contain" data-id="element-80" />
            <div data-id="element-81">
              <div className="text-sm font-semibold text-foreground" data-id="element-82">
                CES Mobile Truck Repair
              </div>
              <div className="text-xs text-muted-foreground" data-id="element-83">
                Cioffi Express Services · Buyer Operations Portal
              </div>
            </div>
          </div>

          <div className="flex items-center gap-4 text-xs text-muted-foreground" data-id="element-84">
            <span className="inline-flex items-center gap-1.5" data-id="element-85">
              <Lock className="h-3 w-3" data-id="element-86" />
              Private & Confidential
            </span>
            <span className="inline-flex items-center gap-1.5" data-id="element-87">
              <MapPin className="h-3 w-3" data-id="element-88" />
              Central Florida
            </span>
            <button onClick={() => window.scrollTo({
            top: 0,
            behavior: 'smooth'
          })} className="hover:text-foreground transition-colors" data-id="element-89">
              Back to top ↑
            </button>
          </div>
        </div>
      </div>
    </footer>;
}